export default function genGid(type, teamId, playerId, agentId, abilitySlot) {
  let gid = type
  gid += teamId ? `-${teamId.toLowerCase()}` : ''
  gid += playerId ? `-${playerId.toLowerCase()}` : ''
  gid += agentId ? `-${agentId.toLowerCase()}` : ''
  gid += abilitySlot ? `-${abilitySlot.toLowerCase()}` : ''

  return gid
}
